import Route from '@ember/routing/route';
import { service } from '@ember/service';
import FundsService, {
  AllFundsInfo,
} from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import TaskService from 'donor-elf-web/services/task-service';

export interface TasksV2AssignedIndexRouteModel {
  allFundsInfo: AllFundsInfo;
}

export default class TasksV2AssignedIndexRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare taskService: TaskService;

  beforeModel() {
    this.navbarSettings.title = 'Tasks';
  }

  async model(): Promise<{ allFundsInfo: AllFundsInfo }> {
    await this.taskService.load();
    let allFundsInfo = await this.fundsService.getAllFundsInfo();
    return {
      allFundsInfo,
    };
  }
}
